import { useOutletContext } from "react-router-dom";

import SectionLabel from "../../../app/universalComponents/SectionLabel";
import Button from "../../../app/universalComponents/Button";
import TicketCutout from "../../../app/universalComponents/TicketCutout";
import StatusIndicator from "../../../app/universalComponents/StatusIndicator";
import { formatSalesWindow, formatInventory, formatStatus } from "../../../app/utils/formatting";
import { useEffect, useState } from "react";
import TicketTypeModal from "./TicketTypeForm";
import TicketActions from "./TicketTypeActions";

export default function TicketsTab() {
    const { activeEvent } = useOutletContext();
    console.log(activeEvent.ticket_types)

    const [modal, setModal] = useState(null);

    useEffect(() => {
        setModal(null);
    }, [activeEvent.ticket_types]);

    return (
        <>
            <div className="mx-auto w-full max-w-4xl p-4">
                <div className="flex items-center justify-between gap-4">
                    <SectionLabel>Ticket Batches</SectionLabel>
                </div>
                <ul className="space-y-4">
                    {activeEvent.ticket_types.map((ticket) => {
                        return (
                            <li key={ticket.id} className="border p-4">
                                <article className="grid gap-2 md:gap-4 md:grid-cols-7">
                                    <TicketCutout className="w-full h-fit p-4 col-span-7 md:col-span-3">
                                        <div className="min-w-0">
                                            <h3 className="truncate text-2xl">{ticket.name}</h3>
                                            {ticket.description ? (
                                                <p className="mt-1 line-clamp-2 text-sm">
                                                    {ticket.description}
                                                </p>
                                            ) : (
                                                <p className="mt-1 text-sm text-gray-500">
                                                    No Description
                                                </p>
                                            )}
                                        </div>
                                        <hr className="my-2 border-black border-t-2 border-dashed" />
                                        <p className="text-2xl text-gray-900">
                                            €{Number(ticket.price).toFixed(2)}
                                        </p>
                                    </TicketCutout>


                                    <div className="flex justify-between min-w-0 flex-col col-span-7 md:col-span-4">
                                        <dl className="grid gap-2 border-gray-200 p-2 sm:grid-cols-3">
                                            <div className="min-w-0">
                                                <dt className="text-sm  text-gray-500">
                                                    Inventory
                                                </dt>
                                                <dd>
                                                    {formatInventory(ticket.inventory_cap)}
                                                </dd>
                                            </div>

                                            <div className="min-w-0">
                                                <dt className="text-sm text-gray-500">
                                                    Max per Buyer
                                                </dt>
                                                <dd>
                                                    {ticket.max_buy == null
                                                        ? "Unlimited"
                                                        : `${ticket.max_buy} ${Number(ticket.max_buy) === 1
                                                            ? "ticket"
                                                            : "tickets"
                                                        }`}
                                                </dd>
                                            </div>

                                            <div className="min-w-0">
                                                <dt className="text-sm text-gray-500">
                                                    Sales Window
                                                </dt>
                                                <dd>
                                                    {formatSalesWindow(ticket.sales_start_at_date, ticket.sales_end_at_date)}
                                                </dd>
                                            </div>

                                        </dl>
                                        {!["past", "cancelled"].includes(activeEvent.status) &&

                                            <div className={`mt-auto flex items-center ${activeEvent.status === "draft" ? "justify-end" : "justify-between"} border-t px-2 pt-4`}>
                                                {activeEvent.status !== "draft" &&
                                                    <StatusIndicator tone={ticket.status}>
                                                        {formatStatus(ticket.status)}
                                                    </StatusIndicator>}
                                                <TicketActions event={activeEvent} ticketType={ticket} onEdit={() => setModal({ ticket, mode: "edit" })} />
                                            </div>
                                        }
                                    </div>
                                </article>
                            </li>
                        );
                    })}
                </ul>
                {!["past", "cancelled"].includes(activeEvent.status) && (
                    <Button onClick={() => setModal({ mode: "create" })} className="mt-4 text-sm">Create Ticket Batch</Button>
                )}
            </div>
            {modal && (
                <TicketTypeModal mode={modal.mode} eventId={activeEvent.id} ticketType={modal.ticket} onClose={() => setModal(null)} />
            )}
        </>
    );
}